import StopsList from "./StopsList";
import React from "react";
import { Button, FormHelperText, withStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import FormSectionHeader from "../common/FormSectionHeader";
import appConstants from "../../../../../../../appConstants";

const styles = (theme) => ({
  formHelperText: {
    marginTop: 16,
    display: "flex",
    alignItems: "center",
  },
  info: {
    marginLeft: 8,
    color: theme.TextColor,
  },
  infoIcon: {
    fontSize: 18,
    color: theme.TextColor,
  },
  actionButton: { margin: 8, marginLeft: 24 },
});
class SelectBills extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStopsList: this.getDefaultStopsList(),
      isExpanded: false,
    };
  }

  getDefaultStopsList = () => {
    const { currentStopData } = this.props;
    return [{ ...currentStopData, isChecked: true }];
  };

  updateStopsList = () => {
    const { stopsList, currentStopData } = this.props;
    return [
      ...this.state.selectedStopsList,
      ...stopsList
        .filter(
          (stop) =>
            stop.stopType === appConstants.STOP_TYPE.Delivery &&
            stop.stopId !== currentStopData.stopId
        )
        .map((stop) => {
          return { ...stop, isChecked: false };
        }),
    ];
  };
  showMoreStops = () => {
    this.setState({
      selectedStopsList: [...this.updateStopsList()],
      isExpanded: true,
    });
  };
  updateStopSelection = (stopId) => {
    const { updateStopSelection } = this.props;
    if (stopId === this.props.currentStopData.stopId) {
      return;
    }
    const selectedStopsList = this.state.selectedStopsList.map((stop) => {
      if (stop.stopId === stopId) {
        return { ...stop, isChecked: !stop.isChecked };
      }
      return stop;
    });
    this.setState({
      selectedStopsList,
    });
    updateStopSelection?.(selectedStopsList.filter((stop) => stop.isChecked));
  };
  render() {
    const { classes } = this.props;
    return (
      <>
        <FormSectionHeader label="select bills" uppercase />
        <StopsList
          stopList={this.state.selectedStopsList}
          handleStopSelection={this.updateStopSelection}
        />
        {!this.state.isExpanded && (
          <>
            <FormHelperText className={classes.formHelperText}>
              <InfoOutlinedIcon className={classes.infoIcon} />
              <span className={classes.info}>
                Select other shipments to be dropped along with this shipment.
              </span>
            </FormHelperText>
            <Button
              onClick={this.showMoreStops}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
            >
              Select more bills
            </Button>
          </>
        )}
      </>
    );
  }
}

export default withStyles(styles)(SelectBills);
